const routes = {
    LOGIN:"/",
    MainPage: '/Login',
    PRODUCT: '/product',
    
    
   

}
export default routes;